"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var em_1 = __importDefault(require("polished/lib/helpers/em"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: ", " solid #84959e;\n  font-size: ", ";\n"], ["\n  border: ", " solid #84959e;\n  font-size: ", ";\n"])), em_1["default"](1), em_1["default"](13));
var QuestionWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", " ", ";\n  cursor: pointer;\n  border-bottom: ", " solid #75848c;\n  background: #84959e;\n  color: white;\n"], ["\n  padding: ", " ", ";\n  cursor: pointer;\n  border-bottom: ", " solid #75848c;\n  background: #84959e;\n  color: white;\n"])), em_1["default"](5), em_1["default"](15), em_1["default"](2));
var AnswerWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: ", " ", ";\n  border-top: 0;\n  ", ";\n"], ["\n  padding: ", " ", ";\n  border-top: 0;\n  ", ";\n"])), em_1["default"](5), em_1["default"](15), function (props) {
  var display = 'none';

  if (props.isOpen) {
    display = 'block';
  }

  return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      display: ", ";\n    "], ["\n      display: ", ";\n    "])), display);
});

var WidgetFAQ =
/** @class */
function (_super) {
  __extends(WidgetFAQ, _super);

  function WidgetFAQ(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  WidgetFAQ.prototype.render = function () {
    var _this = this;

    var _a = this.props.data,
        question = _a.question,
        answer = _a.answer;
    return react_1["default"].createElement(Wrapper, null, react_1["default"].createElement(QuestionWrapper, {
      dangerouslySetInnerHTML: {
        __html: question
      },
      onClick: function onClick() {
        _this.setState({
          isOpen: !_this.state.isOpen
        });
      }
    }), react_1["default"].createElement(AnswerWrapper, {
      isOpen: this.state.isOpen,
      dangerouslySetInnerHTML: {
        __html: answer
      }
    }));
  };

  return WidgetFAQ;
}(react_1.PureComponent);

WidgetFAQ.propTypes = {
  data: prop_types_1["default"].shape({
    question: prop_types_1["default"].node.isRequired,
    answer: prop_types_1["default"].node.isRequired
  }).isRequired
};
exports["default"] = WidgetFAQ;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;